import React, { useRef, memo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProductModules() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const modules = [{
    icon: '🔬',
    title: 'Los 12 Pilares de la Despensa Bioactiva',
    pages: 'Páginas 4 y 5',
    subtitle: 'Ingredientes de $1 que funcionan como medicina de $100 — cuando sabes cómo usarlos',
    points: ['El Ajo: El antibiótico natural de amplio espectro y la Regla de los 10 Minutos de Reposo que activa su principio activo, la Alicina', 'El Jengibre: Cómo activa la microcirculación y la termogénesis — y por qué debes rallarlo en lugar de cortarlo', 'La Cúrcuma: El interruptor maestro de la inflamación — y la combinación exacta de 3 ingredientes que la hace 2,000% más biodisponible', 'El Limón: No es solo vitamina C. Es un regulador de pH y un transportador de minerales', 'La Canela: El regulador de glucosa en sangre más accesible del mundo', 'El Romero: El protector de la memoria y la claridad cognitiva']
  }, {
    icon: '☀️',
    title: 'Protocolo "Claridad Mañanera"',
    pages: 'Páginas 6 y 7',
    subtitle: 'Elimina la neblina mental y el cansancio al despertar — sin una sola gota de cafeína',
    points: ['La Infusión de Romero, Menta y Limón que activa tu sistema nervioso de forma natural en menos de 5 minutos', 'Por qué el agua tibia con sal celta debe ser tu primer paso cada mañana', 'Cómo los aceites MCT del coco transportan los polifenoles del Romero directamente a través de la barrera hematoencefálica', 'El checklist de 5 minutos de respiración diafragmática que potencia cualquier infusión matutina']
  }, {
    icon: '🦴',
    title: 'El Fin del Dolor Articular',
    pages: 'Páginas 8, 9 y 10',
    subtitle: 'La Tríada Dorada para reducir la inflamación crónica — resultados visibles en menos de 14 días',
    points: ['La combinación exacta de Cúrcuma + Pimienta Negra + Grasas Saludables que reduce los marcadores de inflamación hasta un 40%', 'El Caldo de "Sostén Ancestral" — receta completa paso a paso para remineralizar y lubricar las articulaciones desde adentro', 'El secreto del vinagre de sidra de manzana para potenciar la extracción natural de colágeno', 'La Técnica del Paño de Jengibre — aplicación externa para activar el flujo sanguíneo local']
  }, {
    icon: '🌿',
    title: 'Reseteo Digestivo Total',
    pages: 'Páginas 11 y 12',
    subtitle: 'Elimina el reflujo, la hinchazón y el malestar post-comida — desde la primera semana',
    points: ['La Mezcla Digestiva de Hinojo, Anís y Comino — la "Trifala casera" que los herbalistas tradicionales han usado durante siglos', 'El secreto de masticar semillas activadas al finalizar cada comida', 'El Kvas de Remolacha Express — limpieza hepática profunda y regeneración del microbioma intestinal en 48 horas']
  }, {
    icon: '🛡️',
    title: 'El Escudo Inmunitario',
    pages: 'Páginas 13 y 14',
    subtitle: 'Tu sistema de defensa natural — activado en minutos cuando más lo necesitas',
    points: ['El Jarabe de Fuego — la combinación de 5 ingredientes de cocina que produce vasodilatación inmediata', 'Por qué las bacterias no desarrollan resistencia a las plantas medicinales', 'El protocolo completo de 3 días para infecciones leves de garganta y vías respiratorias superiores']
  }, {
    icon: '🌙',
    title: 'Ciclo del Sueño y Reset de Cortisol',
    pages: 'Páginas 15 y 16',
    subtitle: 'Apaga tu sistema nervioso y duerme profundo — sin melatonina sintética ni pastillas para dormir',
    points: ['La Leche de Luna — la combinación de adaptógenos naturales con Magnesio de almendras y cacao', 'El Ritual del Apagado Parasimpático — Infusión de Valeriana y Manzanilla a baja temperatura', 'El secreto de la pizca de sal marina y miel cruda que evita los picos de cortisol a las 3 de la madrugada']
  }];
  return <section ref={ref} className="py-10 md:py-16 px-4 bg-white" data-id="element-245">
      <div className="max-w-6xl mx-auto" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-247">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-warm-brown mb-3 md:mb-4 px-2" data-id="element-248">
            🌿 SINERGIA ANCESTRAL
          </h2>
          <p className="text-xl md:text-2xl lg:text-3xl text-terracotta font-heading mb-4 md:mb-6 px-2" data-id="element-249">
            El Código Maestro de la Salud Natural para Mayores de 50 Años
          </p>
          <p className="text-base md:text-lg lg:text-xl text-gray-700 max-w-3xl mx-auto px-2" data-id="element-250">
            <strong data-id="element-251">20 páginas de valor puro y aplicable</strong> — con más de
            30 recetas probadas, 6 protocolos completos, una guía técnica de
            preparación y un plan de transformación de 30 días.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-8 md:mb-12" data-id="element-252">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream rounded-lg p-6 md:p-8 border-2 border-sage-light hover:border-sage transition-colors shadow-lg" data-id="element-253">
              <div className="text-4xl md:text-5xl mb-3 md:mb-4" aria-hidden="true" data-id="element-254">
                {module.icon}
              </div>
              <h3 className="font-heading text-xl md:text-2xl text-gray-900 mb-2" data-id="element-255">
                {module.title}
              </h3>
              <p className="text-xs md:text-sm text-sage-dark font-semibold mb-2 md:mb-3" data-id="element-256">
                {module.pages}
              </p>
              <p className="text-base md:text-lg font-semibold text-terracotta mb-3 md:mb-4 italic" data-id="element-257">
                "{module.subtitle}"
              </p>
              <ul className="space-y-2 md:space-y-3" data-id="element-258">
                {module.points.map((point, pointIndex) => <li key={pointIndex} className="flex gap-2 md:gap-3 items-start text-gray-700 text-sm md:text-base" data-id="element-259">
                    <span className="text-sage flex-shrink-0 mt-1" aria-hidden="true" data-id="element-260">
                      ✦
                    </span>
                    <span data-id="element-261">{point}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="bg-gradient-to-r from-sage-light/30 to-terracotta-light/20 rounded-lg p-6 md:p-8 border-2 border-sage" data-id="element-262">
          <h3 className="font-heading text-xl md:text-2xl text-gray-900 mb-3 md:mb-4" data-id="element-263">
            🧪 GUÍA TÉCNICA: Cómo Preparar Medicina Real
          </h3>
          <p className="text-base md:text-lg text-gray-700 mb-3 md:mb-4 italic" data-id="element-264">
            "La diferencia entre tomar agua con sabor y tomar medicina que
            realmente funciona"
          </p>
          <ul className="space-y-2 md:space-y-3 text-gray-700 text-sm md:text-base" data-id="element-265">
            <li className="flex gap-2 md:gap-3 items-start" data-id="element-266">
              <span className="text-sage flex-shrink-0 mt-1" aria-hidden="true" data-id="element-267">
                ✦
              </span>
              <span data-id="element-268">
                <strong data-id="element-269">Decocción vs. Infusión vs. Maceración</strong> — cuándo
                y cómo usar cada técnica para extraer el máximo de principios
                activos sin destruirlos
              </span>
            </li>
            <li className="flex gap-2 md:gap-3 items-start" data-id="element-270">
              <span className="text-sage flex-shrink-0 mt-1" aria-hidden="true" data-id="element-271">
                ✦
              </span>
              <span data-id="element-272">
                Por qué la temperatura del agua es la variable más ignorada y
                más crítica en toda la fitoterapia
              </span>
            </li>
            <li className="flex gap-2 md:gap-3 items-start" data-id="element-273">
              <span className="text-sage flex-shrink-0 mt-1" aria-hidden="true" data-id="element-274">
                ✦
              </span>
              <span data-id="element-275">
                Las interacciones importantes que debes conocer si tomas
                medicamentos como Warfarina o fármacos para la diabetes
              </span>
            </li>
            <li className="flex gap-2 md:gap-3 items-start" data-id="element-276">
              <span className="text-sage flex-shrink-0 mt-1" aria-hidden="true" data-id="element-277">
                ✦
              </span>
              <span data-id="element-278">
                La Regla de Oro de los Ciclos — 3 semanas de uso seguidas de 1
                semana de descanso
              </span>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}